import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import HeaderStatistic from '../HeaderStatistic'
import urlForKit from '../../utilities/urlForKit'
import urlForUser from '../../utilities/urlForUser'
import urlForPost from '../../utilities/urlForPost'
import Icon from '../Icon'
import styles from './PostTitle.icss'

class PostTitle extends React.Component {
	render() {
		const { iconName, title, onContextClick, subtitle, counts, onClick, href } = this.props
		const anchorProps = { href: (onClick && !href ? 'javascript:void()' : href) || '#' } // eslint-disable-line no-script-url
		return (
			<section className={styles.title}>
				<div className={styles.titleBars}>
					<div className={styles.titleBar}>
						{iconName && <Icon name={iconName} className={styles.itemTypeIcon} />}
						<div className={styles.titleText}>{title}</div>
					</div>
					<div>
						<div className={styles.subtitleText}>{Array.isArray(subtitle) ? subtitle.map(cat => (cat ? cat.charAt(0).toUpperCase() + cat.slice(1) : undefined)).join(', ') : subtitle}</div>
					</div>
				</div>
				{counts && (
					<div className={styles.headerStat}>
						{counts.map((count) => {
							const aProps = { ...anchorProps }
							if (count.kitId) {
								aProps.href = urlForKit({ kitId: count.kitId })
							} else if (count.userName) {
								aProps.href = urlForUser({ userName: count.userName })
							} else if (count.postId) {
								aProps.href = urlForPost({ postId: count.postId })
							}

							return (
								<HeaderStatistic
									anchorProps={onClick ? undefined : aProps}
									onClick={onClick}
									count={count.count}
									name={count.name}
									key={count.name}
								/>
							)
						})}
					</div>
				)}
				{onContextClick && (
					<div className={styles.contextBtn}>
						<IconButton aria-label="Context" onClick={onContextClick}>
							<MoreVertIcon />
						</IconButton>
					</div>
				)}
			</section>
		)
	}
}


PostTitle.contextTypes = {
	translate: PropTypes.func
}

PostTitle.propTypes = {
	iconName: PropTypes.string,
	href: PropTypes.string,
	onClick: PropTypes.func,
	onContextClick: PropTypes.func,
	subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.string), PropTypes.string]), // eslint-disable-line react/forbid-prop-types
	counts: PropTypes.oneOfType([PropTypes.func, PropTypes.array]), // eslint-disable-line react/forbid-prop-types
	title: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}

PostTitle.defaultProps = {
	iconName: undefined,
	onClick: undefined,
	href: undefined,
	onContextClick: undefined,
	subtitle: undefined,
	counts: undefined,
	title: undefined
}


export default PostTitle



// WEBPACK FOOTER //
// ./src/components/Item/PostTitle.jsx